/**
 * Резервные стабы переводов, чтобы показать элементы UI когда апи упало
 */
const stubs = {
  'help.common.startBetting': {
    curacao: {
      ko: '웹사이트를 방문하십시오',
      hu: 'A webhely felkeresése',
      mx: 'Visite el sitio web',
      uy: 'Visite el sitio web',
      en: 'Visit the website',
      az: 'Veb-saytda daxil ol',
      es: 'Visite el sitio web',
      co: 'Visite el sitio web',
      cl: 'Visite el sitio web',
      pe: 'Visite el sitio web',
      ec: 'Visite el sitio web',
      fr: 'Consulter le site Internet',
      hr: 'Posjeti web-mjesto',
      ind: 'Visit the website',
      in: 'Kunjungi situs webnya',
      pt: 'Visite o site',
      br: 'Acesse o site',
      sr: 'Posetite veb-sajt',
      tr: 'İnternet sitesini ziyaret edin',
      vi: 'Truy cập trang web',
      mn: 'Вебсайтаар зочлох',
      su: 'Перейти на сайт',
      uk: 'Перейти на вебсайт',
      uz: 'Веб-сайтга ташриф буюринг',
      uzb: 'Veb-saytga tashrif buyuring',
      th: 'เยี่ยมชมเว็บไซต์',
      ka: 'ესტუმრეთ ვებგვერდს',
      zh: '访问网站',
      it: 'Visita il sito web',
      da: 'Besøg hjemmesiden',
      tw: '訪問網站',
    },
    denmark: {
      en: 'Visit the website',
      da: 'Besøg hjemmesiden',
    },
    belarussia: {
      su: 'Перейти на сайт',
      en: 'Visit the website',
      be: 'Перайсці на сайт',
    },
    russia: {
      su: 'Перейти на сайт',
    },
    spain: {
      es: 'Visite el sitio web',
      en: 'Visit the website',
      su: 'Перейти на сайт',
    },
    italy: {
      it: 'Visita il sito web',
      en: 'Visit the website',
    },
  },
  'help.common.title': {
    russia: {
      su: 'Правила',
    },
    belarussia: {
      su: 'Правила',
      en: 'Help',
      be: 'Правілы',
    },
    italy: {
      it: 'Guida',
      en: 'Help',
    },
    spain: {
      es: 'Ayuda',
      en: 'Help',
      su: 'Правила',
    },
    denmark: {
      en: 'Help',
      da: 'Hjælp',
    },
    curacao: {
      ko: '문의',
      en: 'Help',
      th: 'ความช่วยเหลือ',
      az: 'Kömək',
      br: 'Ajuda',
      cl: 'Ayuda',
      da: 'Hjælp',
      es: 'Ayuda',
      ec: 'Ayuda',
      co: 'Ayuda',
      mx: 'Ayuda',
      uy: 'Ayuda',
      fr: 'Aide',
      hi: 'help',
      hr: 'Pomoć',
      in: 'Bantuan',
      ind: 'Help',
      tw: 'Help',
      hu: 'Súgó',
      mn: 'Тусламж',
      uzb: 'Yordam',
      pe: 'Ayuda',
      pt: 'Ajuda',
      sr: 'Pomoć',
      tr: 'Yardım',
      vi: 'Trợ giúp',
      be: 'Правілы',
      su: 'Правила',
      uk: 'Правила',
      uz: 'Ёрдам',
      ka: 'დახმარება',
      zh: '帮助',
      it: 'Guida',
    },
  },
  'help.common.copyright': {
    curacao: {
      en: '{0,number,#} Copyright',
      az: '{0,number,#} Müəllif hüququ',
      es: '{0,number,#} Copyright',
      cl: '{0,number,#} Copyright',
      pe: '{0,number,#} Copyright',
      ec: '{0,number,#} Copyright',
      fr: '{0,number,#} Copyright',
      hr: '{0,number,#} Autorska prava',
      ind: '{0,number,#} Copyright',
      in: '{0,number,#} Hak Cipta',
      pt: '{0,number,#} Copyright',
      br: '{0,number,#} Direitos autorais',
      sr: '{0,number,#} Copyright',
      tr: '{0,number,#} Telif hakkı',
      vi: 'Bản quyền {0,number,#}',
      mn: '{0,number,#} Зохиогчийн эрх',
      su: '{0,number,#} Copyright',
      uk: '{0,number,#} Copyright',
      uz: '{0,number,#} Муаллифлик ҳуқуқи',
      uzb: '{0,number,#} Mualliflik huquqi',
      th: '{0,number,#} สงวนลิขสิทธิ์',
      ka: '{0,number,#} საავტორო უფლება',
      zh: '{0,number,#} 版权所有',
      it: '{0,number,#} Autorinės teisės',
      da: '{0,number,#} Copyright',
      tw: '{0,number,#} 版權所有',
    },
    russia: {
      su: '{0,number,#} ООО «Букмекерская контора «Марафон»',
    },
    spain: {
      es: 'Marathonbet Spain, S.A. cuenta con las oportunas licencias para operar en España emitidas por la Dirección General de Ordenación del Juego.<br>Marathonbet Spain, S.A. 2017, todos los <a href="https://www.marathonbet.es/es/help/terms_and_conditions/" target="_blank">derechos de la web</a> están reservados.',
      en: 'Marathonbet Spain, S.A. operates under gaming licenses issued by the Directorate General for the Regulation of Gambling.<br>Marathonbet Spain, S.A. 2017, <a href=" https://www.marathonbet.es/en/help/terms_and_conditions/" target="_blank">all rights</a> are reserved.',
      su: 'Marathonbet Spain, S.A. operates under gaming licenses issued by the Directorate General for the Regulation of Gambling.<br>Marathonbet Spain, S.A. 2017, <a href=" https://www.marathonbet.es/en/help/terms_and_conditions/" target="_blank">all rights</a> are reserved.',
    },
    denmark: {
      en: '{0,number,#} Copyright Marathon Alderney Ltd.',
      da: '{0,number,#} Copyright Marathon Alderney Ltd.',
    },
    italy: {
      it: 'Il sito Marathonbet.it è gestito da Marathonbet Italy S.r.l con sede legale in Via Savoia 23, 00198 Roma RM, Italia. Partita IVA n. 14029401008, Concessione GAD n. 15002.',
      en: 'The website Marathonbet.it is operated by Marathonbet Italy S.r.l. with registered office in Via Savoia 23, 00198 Roma RM, Italy. Fiscal code n. 14029401008, Concession GAD n. 15002.',
    },
    belarussia: {
      su: 'Специальное разрешение (лицензия) № 33120/171 выдано Министерством по налогам и сборам Республики Беларусь',
      en: 'Special Permit (Licence) No. 33120/171 issued by the Tax and Duties Ministry of the Republic of Belarus',
      be: 'Спецыяльны дазвол (ліцэнзія) № 33120/171 выдадзена Міністэрствам па падатках і зборах Рэспублікі Беларусь',
    },
  },
  'help.common.e500.title': {
    en: 'Service is Temporarily <br/>Unavailable',
    su: 'Сервис временно <br/>недоступен',
  },
  'help.common.e500.text': {
    en: 'Unknown problem appeared. <br/>Our technical specialists are fixing it.',
    su: 'Произошла ошибка <br/>Наши специалисты уже решают её',
  },
  'help.contacts': {
    russia: {
      su: ' ',
    },
    belarussia: {
      su: ' ',
      en: ' ',
      be: ' ',
    },
    curacao: {
      hu: '<p>Ügyfélszolgálat és telefonos fogadás<br>Angol nyelvű segítség éjjel-nappal</p><div class="footer-phone-column"><a href="tel:+44 1273 964706">+44 1273 964706</a></div>',
      en: '<p>Customer Support</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      su: '<p>Служба поддержки 24/7:</p><div class="footer-phone-column"><div class="text">Из России</div><a href="tel:81080029034010">8 10800 290 340 10</a></div> <div class="footer-phone-column"><div class="text">Из других стран</div><a href="tel:+441273964704">+44 1273 964704</a></div>',
      az: '<p>Müştəri Xidməti</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      es: '<p>Atención al Cliente<br>08:00-06:00 (GMT+1)</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      cl: '<p>Atención al Cliente<br>04:00-02:00</p><div class="footer-phone-column"><a href="tel:+441273964706">800914880</a></div>',
      pe: '<p>Atención al Cliente<br>02:00-00:00</p><div class="footer-phone-column"><a href="tel:+441273964706">080 071 084</a></div>',
      ec: '<p>Atención al Cliente<br>02:00-00:00</p><div class="footer-phone-column"><a href="tel:+441273964706">1800001069</a></div>',
      fr: '<p>Service client</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      hr: '<p>Korisnička podrška</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      ind: '<p>Customer Support</p><div class="footer-phone-column"><a href="tel:0008000502017">0008000502017</a></div>',
      in: '<p>Dukungan Pelanggan</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      pt: '<p>Serviço de apoio ao cliente</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      br: '<p>Atendimento ao Сliente<br>18:00 – 02:00 (GMT-3)</p><div class="footer-phone-column"><a href="tel:08008913780">08008913780</a></div>',
      sr: '<p>Korisničku podrška</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      tr: '<p>Müşteri Servisi<br></p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      vi: '<p>Bộ phận Hỗ trợ Khách hàng</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      mn: '<p>Хэрэглэгчийн дэмжлэг</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      uk: '<p>Служба підтримки 24/7:</p><div class="footer-phone-column"><div class="text">З України</div><a href="tel:0800801172">0800801172</a></div> <div class="footer-phone-column"><div class="text">З інших країн</div><a href="tel:+441273964704">+44 1273 964704</a></div>',
      uz: '<p>Мижозларга хизмат кўрсатиш маркази</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      uzb: '<p>Mijozlarga xizmat ko\'rsatish markazi</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      th: '<p>ฝ่ายบริการลูกค้า</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      ka: '<p>კლიენტების მხარდაჭერა</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
      zh: '<p>联系我们：</p><div class="footer-phone-column"><a href="tel:+44 1273 964706">+44 1273 964706</a></div>',
      tw: '聯系我們：<br>中文客服熱線：<strong>400&nbsp;1204849</strong> (國內付費)<br><br>其它語言客服：<strong>+44&nbsp;1273&nbsp;964706</strong> (國際付費）',
      ko: '<p>고객센터 &amp; 전화 베팅</p><div class="footer-phone-column"><a href="tel:+441273964706">+44 1273 964706</a></div>',
    },
    spain: {
      en: '<p>Responsible Gambling</p><div class="footer-phone-column"><a href="tel:900876522">900 876 522</a></div>',
      su: '<p>Ответственная игра</p><div class="footer-phone-column"><a href="tel:900876522">900 876 522</a></div>',
      es: '<p>Juego Responsable</p><div class="footer-phone-column"><a href="tel:900876522">900 876 522</a></div>',
    },
    italy: {
      en: '<p>Customer Support<br>08:00 – 21:45</p><div class="footer-phone-column"><a href="tel:800959107">800959107</a></div>',
      it: '<p>Servizio Clienti<br>08:00 – 21:45</p><div class="footer-phone-column"><a href="tel:800959107">800959107</a></div>',
    },
    denmark: {
      en: '<p>Customer Support<br>11:00 – 19:00</p><div class="footer-phone-column"><a href="tel:80711145">80711145</a></div>',
      da: '<p>Kundesupport<br>11:00 - 19:00</p><div class="footer-phone-column"><a href="tel:80711145">80 71 11 45</a></div>',
      su: '<p>Служба поддержки 24/7:</p><div class="footer-phone-column"><div class="text">Из России</div><a href="tel:81080029034010">8 10800 290 340 10</a></div><div class="footer-phone-column"><div class="text">Из других стран</div><a href="tel:+441273964704">+44 1273 964704</a></div>',
    },
  },
} as Record<string, any>;

export default (locale: string, list: string[]) => {
  const result = {} as Record<string, string>;
  list
    .forEach((item: string) => {
      if (item === 'help.contacts' || item === 'help.common.copyright' || item === 'help.common.startBetting' || item === 'help.common.title') {
        if (window.location.host.indexOf('com') !== -1 || window.location.host.indexOf('cur') !== -1) {
          result[item] = !!locale && !!stubs[item]['curacao'][locale] ? stubs[item]['curacao'][locale] : stubs[item]['curacao']['en'];
        } else if (window.location.host.indexOf('.es') !== -1 || window.location.host.indexOf('es1') !== -1) {
          result[item] = !!locale && !!stubs[item]['spain'][locale] ? stubs[item]['spain'][locale] : stubs[item]['spain']['en'];
        } else if (window.location.host.indexOf('.it') !== -1 || window.location.host.indexOf('it1') !== -1) {
          result[item] = !!locale && !!stubs[item]['italy'][locale] ? stubs[item]['italy'][locale] : stubs[item]['italy']['en'];
        } else if (window.location.host.indexOf('.dk') !== -1 || window.location.host.indexOf('dk1') !== -1) {
          result[item] = !!locale && !!stubs[item]['denmark'][locale] ? stubs[item]['denmark'][locale] : stubs[item]['denmark']['en'];
        } else if (window.location.host.indexOf('.ru') !== -1 || window.location.host.indexOf('ru1') !== -1) {
          result[item] = !!locale && !!stubs[item]['russia'] ? stubs[item]['russia']['su'] : stubs[item]['curacao'][locale];
        } else if (window.location.host.indexOf('.by') !== -1 || window.location.host.indexOf('by1') !== -1) {
          result[item] = !!locale && !!stubs[item]['belarussia'][locale] ? stubs[item]['belarussia'][locale] : stubs[item]['curacao'][locale];
        } else {
          result[item] = '';
        }
      } else {
        result[item] = !!locale && !!stubs[item][locale] ? stubs[item][locale] : stubs[item]['en'];
      }
    });
  return result;
};
